<template>
    <ShadowBoxContainer>

        <CardShell class="col-sm-9 center mt4-ns">
            <StepProgress :currentStep="1" :totalSteps="11"/>
            <ListHeader
                class="ph3 ph4-ns"
                :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
                imageLabel="General Information"
                heading="What category does this belong to?"
            />

            <BackCategory :categoryName="subCategory.name" @click="goBack()" class="pointer"></BackCategory>
            <WhiteCategory v-for="(category, index) in subCategory.children" :key="index" :categoryName="category.name" :hasChild="category.children.length > 0" @select="select(index)" :isSelected="selectedIndex === index" />
        </CardShell>

        <!-- navigation buttons -->
        <template slot="actionBar">
            <NavigationButtons :enabledForward="selectedIndex !== null" back="Back" forward="Next" @backClick="$router.push('/category')" @forwardClick="next" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import CardShell from '@/components/global/CardShell.vue';
import StepProgress from '@/components/controls/StepProgress.vue';
import ListHeader from '@/components/list/shared/ListHeader.vue';
import BackCategory from '@/components/list/shared/BackCategory.vue';
import WhiteCategory from '@/components/list/shared/WhiteCategory.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        ShadowBoxContainer,
        CardShell,
        StepProgress,
        ListHeader,
        BackCategory,
        WhiteCategory,
        NavigationButtons
    },
    data() {
        return {
            selectedIndex: null,
            index: []
        };
    },
    computed: {
        ...mapState('newListing', ['allCategories']),
        subCategory() {
            var category = { children: this.allCategories };

            this.index.forEach(index => {
                category = category.children[index];
            });

            return category;
        }
    },
    methods: {
        ...mapMutations('newListing', ['setCategoryId']),
        select(index) {
            if (this.subCategory.children[index].children.length > 0) {
                this.selectedIndex = null;
                this.$router.push({
                    query: { index: [...this.$route.query.index, index] }
                });
            } else {
                this.selectedIndex = index;
            }
        },
        goBack() {
            if (this.$route.query.index.length > 1) {
                this.$router.push({
                    query: { index: this.$route.query.index.slice(0, -1) }
                });
            } else {
                this.$router.push('/category');
            }
        },
        updateIndex() {
            this.index = Array.isArray(this.$route.query.index)
                ? this.$route.query.index
                : [this.$route.query.index];
        },
        next() {
            var categoryId = this.subCategory.children[this.selectedIndex].id;
            this.setCategoryId(categoryId);
            this.$router.push('/brand');
        }
    },
    watch: {
        $route() {
            this.updateIndex();
        }
    },
    created: function() {
        this.updateIndex();
    }
};
</script>
